<div #menu [style.background]="backgroundColor" class="menu-container">
  <ng-container *ngFor="let header of headers">
    <ng-container *ngIf="fragment; else noFragment">
      <a [fragment]="header.fragment"
         [routerLink]="header.path"
         [style.border-top-color]="backgroundColor"
         [style.color]="textColor"
         [style.height]="menuHeight">
        {{ header.headerText }}</a>
    </ng-container>
    <ng-template #noFragment>
      <a #rla="routerLinkActive"
         [ngClass]="{'arrow-box' : rla.isActive}"
         [routerLink]="header.path"
         [style.border-top-color]="backgroundColor"
         [style.color]="textColor"
         [style.height]="menuHeight"
         routerLinkActive="true">
        {{ header.headerText }}</a>
    </ng-template>
  </ng-container>
</div>
